import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SquareCheckbox from 'modules/shared/components/inputs/SquareCheckbox';
import OverlayButtonsList from 'modules/shared/components/top/Overlay/overlay-buttons';
import RoundButton from 'modules/shared/components/top/Overlay/RoundButton';
import React, { ReactElement, useState } from 'react';

import { FormValues } from '../types';
import {
  Backdrop,
  CheckboxContainer,
  CheckboxWrapper,
  ChecklistPreview,
  CloseWrapper,
  Container,
  Header,
  TitleWrapper,
  Wrapper,
} from './styles';

function CustomerChecklist({
  checklist,
  customisedMessage,
  links,
}: FormValues): ReactElement {
  const [selection, setSelection] = useState<string[]>([]);

  function toggleSelection(label: string) {
    if (selection.includes(label)) {
      return setSelection(selection.filter((item) => item !== label));
    }

    setSelection([...selection, label]);
  }

  const buttonList = OverlayButtonsList(true);

  return (
    <ChecklistPreview>
      <Backdrop />
      <Container>
        <Header>
          {buttonList.map(({ buttonName, buttonLabel }) => (
            <RoundButton
              key={buttonName}
              label={buttonLabel}
              sideBarName={buttonName}
              forcedActive={buttonName === 'checklist'}
            />
          ))}
        </Header>
        <Wrapper>
          <CloseWrapper>
            <FontAwesomeIcon
              color="#666666"
              icon={['fas', 'times-circle']}
              size="lg"
            />
          </CloseWrapper>
          <div className="columns is-multiline">
            <div className="column is-12">
              <TitleWrapper>Checklist</TitleWrapper>
              <p>
                {customisedMessage
                  ? customisedMessage
                  : 'Welcome! Please make sure you have the documents below.'}
              </p>
            </div>
            {checklist.length > 0 && (
              <div className="column is-12">
                <CheckboxWrapper className="columns is-multiline">
                  {checklist.map(({ label }, index) => (
                    <div
                      className="column is-12"
                      key={`checklist-checkbox-render-${index}`}
                    >
                      <CheckboxContainer>
                        <SquareCheckbox
                          key={`checklist-item-${index}`}
                          label={label}
                          checkboxId={`checklist-item-${index}`}
                          handleChange={() => toggleSelection(label!)}
                          checked={selection.includes(label!)}
                        />
                      </CheckboxContainer>
                    </div>
                  ))}
                </CheckboxWrapper>
              </div>
            )}
            {links.length > 0 && (
              <div className="column is-12">
                <TitleWrapper>Links</TitleWrapper>
                {links.map(({ label, value }, index) => (
                  <div key={`link-render-${index}`}>
                    <a href={value} target="_blank" rel="noopener noreferrer">
                      {label || value}
                    </a>
                  </div>
                ))}
              </div>
            )}
          </div>
        </Wrapper>
      </Container>
    </ChecklistPreview>
  );
}

export default CustomerChecklist;
